/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import CategoriesIcon from 'icons/CategoriesIcon';

const messages = defineMessages({
  title: {id: 'navigation.grants.categories'},
});

const CategoriesItem = () => (
  <RouteLinkItem
    iconBefore={CategoriesIcon}
    route="midas/grants/categories"
    title={messages.title}
  />
);

export default CategoriesItem;
